(function () {
  var hd = document.getElementById('mlw-hd');
  if (hd) {
    var onScroll = function () { hd.classList.toggle('stuck', window.scrollY > 8); };
    onScroll();
    addEventListener('scroll', onScroll, { passive: true });
  }
  var burger = document.getElementById('mlw-burger');
  var mnav = document.getElementById('mlw-mnav');
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      var open = mnav.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
})();
